module.exports = __webpack_public_path__ + "static/logo-alt-numerique.c70ae612.svg";